import Footer from '../Footer';
import Navbar from '../Navbar';
import Topic5 from '../blog/topic5';


function App() {
  return (
    <>
      <Navbar />
      <Topic5 />
      <Footer />
    </>
  );
}

export default App;